import {
	Box,
	Breadcrumbs,
	Card,
	CardContent,
	Link,
	List,
	ListItem,
	ListItemText,
	Skeleton,
	Typography,
} from '@mui/material'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useGetQuestionDetailsQuery } from '../store/api/vacanciesApi'

const statusMapping: { [key: string]: string } = {
	PENDING: 'Очікує відповіді',
	ACTIVE: 'Відповідь заповнюється',
	FINISHED: 'Відповідь отримана',
	DECLINED: 'Відхилено',
}

const QuestionPage = () => {
	const params = useParams()
	const navigate = useNavigate()

	const { data, isLoading } = useGetQuestionDetailsQuery(params.id)

	return (
		<Box>
			<Breadcrumbs sx={{ mb: '16px' }} separator="›" aria-label="breadcrumb">
				<Link
					underline="hover"
					color="inherit"
					onClick={() => navigate('/questions')}
				>
					Уточення
				</Link>
				<Typography key="3" sx={{ color: 'text.primary' }}>
					{isLoading || !data ? (
						<Skeleton
							variant="text"
							sx={{ fontSize: '16px', width: '160px' }}
						/>
					) : (
						data.candidate_name + ' - ' + data.vacancy_title
					)}
				</Typography>
			</Breadcrumbs>
			<Box sx={{ display: 'flex', justifyContent: 'center' }}>
				{isLoading || !data ? (
					<Skeleton variant="rectangular" height={600} width={700} />
				) : (
					<Card sx={{ maxWidth: '700px', width: '100%' }}>
						<CardContent>
							<Typography variant="h5" component="div" gutterBottom>
								Деталі уточнення
							</Typography>
							<Typography color='textSecondary'>
								{new Date(data.created_at).toLocaleString()}
							</Typography>
							<Typography sx={{mb: 1}}>
								{statusMapping[data.status] || data.status}
							</Typography>
							<Box
								sx={{
									border: '1px solid',
									borderColor: 'gray.500',
									borderRadius: 2,
									p: 1,
								}}
							>
								<Typography>Запит: {data.extra_notes}</Typography>
							</Box>
							<List>
								{data.questions.map((question, index) => (
									<ListItem key={index}>
										<ListItemText primary={question} secondary={data.answers[index] ?? 'Відповідь не надана'} />
									</ListItem>
								))}
							</List>
						</CardContent>
					</Card>
				)}
			</Box>
		</Box>
	)
}

export default QuestionPage
